import { render, staticRenderFns } from "./ShowSelectedObjectStore.vue?vue&type=template&id=05e320ee&"
import script from "./ShowSelectedObjectStore.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShowSelectedObjectStore.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports